export default "__VITE_ASSET__BrjHhUo0__"